export default __webpack_public_path__ + "media/icons/inactive-sml-4a246cfd.svg";